// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__W8D_a","title":"Header_title__4Yku7","left":"Header_left__22vWd","clinicName":"Header_clinicName__33-Cb"};